export const SET_FACILITY = 'SET_FACILITY';
export const SET_DEPARTMENT = 'SET_DEPARTMENT';
export const SET_CLINIC = 'SET_CLINIC';